class CountDownComponent extends HTMLElement {
  constructor() {
    super();
    this.targetTime = this.dataset.time;
    this.days = this.querySelector('[data-days]');
    this.hours = this.querySelector('[data-hour]');
    this.minutes = this.querySelector('[data-minute]');
    this.seconds = this.querySelector('[data-second]');
    this.interval = null;
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    clearInterval(this.interval);
  }
  init() {
    this.update();
    this.interval = setInterval(() => {
      this.update();
    }, 1000);
  }
  update() {
    const [day, month, year] = this.targetTime.split('-');
    const target = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      23,
      59,
      59
    ).getTime();
    const difference = target - Date.now();
    if (difference <= 0) {
      this.days.textContent = '00';
      this.hours.textContent = '00';
      this.minutes.textContent = '00';
      this.seconds.textContent = '00';
      clearInterval(this.interval);
      return;
    }
    const totalSeconds = Math.floor(difference / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    this.days.textContent = String(days).padStart(2, '0');
    this.hours.textContent = String(hours).padStart(2, '0');
    this.minutes.textContent = String(minutes).padStart(2, '0');
    this.seconds.textContent = String(seconds).padStart(2, '0');
  }
}
customElements.define('count-down-component', CountDownComponent);
class SuscriptionWidget extends HTMLElement {
  constructor() {
  super();
    this.dataName = this.dataset.name;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.allInputs = this.querySelectorAll(`[name="${this.dataName}"]`);
    this.productForm = document.querySelector('product-form-component .shopify-product-form[data-type="add-to-cart-form"]');
    if (!this.allInputs.length || !this.productForm) return;
    this.allInputs.forEach(element => {
      element.addEventListener('change', () => this.handleChange(element));
    });
    this.applySelected();
  }
  applySelected() {
    const selected = this.querySelector(`[name="${this.dataName}"]:checked`);
    if (selected) {
      this.handleChange(selected);
    }
  }
  handleChange(element) {
    const dataType = element.dataset.type;
    this.updateSellingPlan(element, dataType);
    this.updateQuantity(element, dataType);
  }
  updateSellingPlan(element, dataType) {
    const existingSellingPlan = document.querySelector('.selected-selling-plan-id');
    if (dataType === 'suscription') {
      if (!existingSellingPlan) {
        const sellingPlanInput = document.createElement('input');
        sellingPlanInput.name = 'selling_plan';
        sellingPlanInput.className = 'selected-selling-plan-id';
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.value = element.value;
        this.productForm.appendChild(sellingPlanInput);
      } else {
        existingSellingPlan.value = element.value;
      }
    } else {
      existingSellingPlan?.remove();
    }
  }
  updateQuantity(element, dataType) {
    if (dataType === 'pack') {
    let quantityInput = this.productForm.querySelector('input[name="quantity"]');
      if (!quantityInput) {
        quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.dataset.pack3 = 'true';
        this.productForm.appendChild(quantityInput);
      }
      quantityInput.value = element.value;
    } else {
      const pack3Quantity = this.productForm.querySelector(
        'input[name="quantity"][data-pack3="true"]'
      );
      pack3Quantity?.remove();
    }
  }
}
customElements.define('suscription-widget-custom', SuscriptionWidget);